import React, { useState } from "react";
import Button from "./button";
import Input from "./input";
import quoteImage from "../../assets/projects/quoteImage.jpeg";

export default function QuoteModal({ open, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    location: "",
  });

  if (!open) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("http://localhost:8000/api/quote", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        alert("Submitted successfully!");
        onClose();
        setFormData({ name: "", phone: "", location: "" });
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-[95%] max-w-5xl rounded-xl overflow-hidden shadow-2xl z-10 grid md:grid-cols-2">

        {/* LEFT IMAGE */}
        <div className="hidden md:block relative">
          <img
            src={quoteImage}
            alt="Project"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30" />
        </div>

        {/* RIGHT FORM */}
        <div className="p-8 md:p-10 relative flex flex-col justify-center">

          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl"
          >
            ✕
          </button>

          {/* Heading */}
          <h2 className="text-3xl font-serif text-[#2C2C2C] mb-2 text-center">
            Get Free Consultation
          </h2>

          {/* Subtext */}
          <p className="text-center text-sm text-gray-500 mb-6">
            Fill enquiry form & our team will reach you within <span className="font-semibold text-[#C2185B]">24 hours</span>
          </p>

          {/* Offer Badge */}
          <div className="text-center mb-6">
            <span className="inline-block bg-[#C2185B]/10 text-[#C2185B] px-4 py-2 text-xs tracking-wider uppercase rounded-full">
              🎉 Exciting Offer Available
            </span>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5">

            {/* Name */}
            <Input
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
            />

            {/* Phone */}
            <Input
              name="phone"
              placeholder="Contact Number"
              value={formData.phone}
              onChange={handleChange}
            />

            {/* Location */}
            <select
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="w-full border-b border-gray-300 py-2 outline-none focus:border-[#C2185B] transition"
            >
              <option value="">Select Location</option>
              <option>Ranchi</option>
              <option>Delhi</option>
              <option>Gurgaon</option>
              <option>Noida</option>
            </select>

            {/* Submit */}
            <Button className="w-full bg-[#C2185B] hover:bg-[#a31448] text-white py-3 text-lg tracking-wide shadow-md hover:shadow-lg transition-all">
              Get Free Consultation
            </Button>

          </form>

          {/* Trust Line */}
          <p className="text-center text-xs text-gray-400 mt-4">
            🔒 Your information is safe & secure
          </p>

        </div>
      </div>
    </div>
  );
}